export default "__VITE_ASSET__3yWA4wS___"